import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetContactLocations =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await PostFunction({
        data: {},
        Route: UrlApi.contact_locations.get,
        showalert: false,
        state: getState,
        dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageContactLocations =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      
      // Backend expects JSON object, not FormData (no file uploads for contact locations)
      const data = {};
      
      if (editMode && values?.id) {
        data.id = values.id;
      }
      
      if (values.location_name) data.location_name = values.location_name.trim();
      if (values.address) data.address = values.address.trim();
      if (values.city) data.city = values.city.trim();
      if (values.country) data.country = values.country.trim();
      if (values.phone) data.phone = values.phone.trim();
      if (values.email) data.email = values.email.trim();
      if (values.map_url) data.map_url = values.map_url.trim();
      if (values.is_primary !== undefined) data.is_primary = Boolean(values.is_primary);
      if (values.display_order !== undefined) data.display_order = values.display_order;
      if (values.is_active !== undefined) data.is_active = Boolean(values.is_active);

      const route = editMode ? UrlApi.contact_locations.edit : UrlApi.contact_locations.add;
      
      const response = await PostFunction({
        data: data,
        Route: route,
        showalert: true,
        state: getState,
        isMultipart: false, // Backend expects JSON, not FormData
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditContactLocations =
  ({ callback, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      // Use JSON object instead of FormData for inline edits
      const data = {
        id: id,
        [nameFailed]: nameFailed === "is_active" || nameFailed === "is_primary" 
          ? Boolean(dataFailed) 
          : dataFailed
      };
      
      const response = await PostFunction({
        data: data,
        Route: UrlApi.contact_locations.edit,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteContactLocations =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const response = await PostFunction({
        data: { ids: id },
        Route: UrlApi.contact_locations.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const SetPrimaryContactLocation =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const response = await PostFunction({
        data: { id },
        Route: UrlApi.contact_locations.setPrimary,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

